








import { Component, Prop, Vue } from "vue-property-decorator";
import { GuidelineApi, DayDone } from "./guidelineApi";

// Marks today from a row (circle) and shows the single confirmation under the list, with "Undo" or "Retry".
// The parent receives the updated row ("row") and which row is waiting ("busy").
@Component
export default class GuidelineRecorder extends Vue {
  @Prop({ type: String, required: true }) today!: string;

  message: string = "";
  undoId: number = 0;
  failed: (() => Promise<void>) | null = null;
  busyId: number = 0;

  async toggle(row: any) {
    if (this.busyId) return;
    if (row.todayStatus === DayDone) {
      await this.undo(row.id);
      return;
    }
    await this.run(row.id, () => GuidelineApi.record(row.id, this.today, DayDone), () => this.toggle(row), (saved: any) => {
      this.message = this.milestone(saved);
      this.undoId = row.id;
    });
  }

  async undo(id: number) {
    await this.run(id, () => GuidelineApi.undo(id, this.today), () => this.undo(id), () => {
      this.message = "";
      this.undoId = 0;
    });
  }

  undoLast() {
    return this.undo(this.undoId);
  }

  retry() {
    const again = this.failed;
    this.failed = null;
    return again ? again() : Promise.resolve();
  }

  async run(id: number, call: () => Promise<any>, again: () => Promise<void>, done: (row: any) => void) {
    this.busyId = id;
    this.$emit("busy", id);
    const res = await call();
    this.busyId = 0;
    this.$emit("busy", 0);
    if (!res || res.ok === false) {
      this.failed = again;
      this.undoId = 0;
      this.message = res && res.errorMsg ? res.errorMsg : this.$t("It was not saved.").toString();
      return;
    }
    this.failed = null;
    this.$emit("row", res.model);
    done(res.model);
  }

  milestone(row: any): string {
    if (row.firstRecord) return this.$t("Your first day recorded").toString();
    if (row.weekCompleted) return this.$t("Week completed in {0}").toString().replace("{0}", row.name);
    return this.$t("Recorded today").toString();
  }
}
